import { Controller } from "@hotwired/stimulus"

// "Do you know what was in it?" — and what the answer reveals.
//
// Numbers before sizes, behind a gate: somebody holding a receipt should not
// have to read three descriptions of meals they did not eat. The same shape
// as the new-food form's units question, so the two screens teach each
// other.
//
// DISABLED, NOT JUST HIDDEN. A hidden field still posts, so without this the
// controller would receive both a typed figure and a size bucket and have to
// guess which was meant. Disabling the half that is not showing makes the
// gate's answer the only thing that decides.
export default class extends Controller {
  static targets = ["known", "unknown", "kcal"]

  connect() {
    this.change()
  }

  change() {
    const knows = this.element.querySelector(
      "input[name='cheat_meal[knows]']:checked"
    )?.value !== "no"

    this.knownTarget.hidden = !knows
    this.unknownTarget.hidden = knows

    this.fieldsIn(this.knownTarget).forEach((f) => { f.disabled = !knows })
    this.fieldsIn(this.unknownTarget).forEach((f) => { f.disabled = knows })

    // REQUIRED ONLY WHILE IT IS ASKED FOR. A cheat meal with no energy is a
    // row that says nothing — it is the one figure the feature exists to
    // capture — but a disabled-and-required field blocks the submit with a
    // message pointing at something nobody can see.
    if (this.hasKcalTarget) this.kcalTarget.required = knows
  }

  fieldsIn(panel) {
    return Array.from(panel.querySelectorAll("input, select, textarea"))
  }
}
